import { useState } from "react";
import "./Forms.css";
import { useTranslation } from "react-i18next";

export default function ConsultorForm() {
    const { t } = useTranslation();

    const SUBJECT_OPTIONS = [
        { value: "SAAS", label: t('forms.subjects.saas', 'SAAS') },
        { value: "Tecnologia Educacional", label: t('forms.subjects.edutech', 'Tecnologia Educacional') },
        { value: "Licenças GWS", label: t('forms.subjects.gws', 'Licenças GWS') },
        { value: "Projetos de Engenharia", label: t('forms.subjects.engineering', 'Projetos de Engenharia') }
    ];

    const INSTITUTION_OPTIONS = [
        { value: "Estado/Governo Federal", label: t('forms.institutions.government', 'Estado/Governo Federal') },
        { value: "Prefeitura", label: t('forms.institutions.city_hall', 'Prefeitura') },
        { value: "Secretaria Municipal/Estadual", label: t('forms.institutions.department', 'Secretaria Municipal/Estadual') },
        { value: "Universidade Pública", label: t('forms.institutions.public_uni', 'Universidade Pública') },
        { value: "Universidade Privada", label: t('forms.institutions.private_uni', 'Universidade Privada') },
        { value: "Empresa Privada", label: t('forms.institutions.private_company', 'Empresa Privada') },
        { value: "Fundação Pública", label: t('forms.institutions.public_foundation', 'Fundação Pública') },
        { value: "Entidade sem fins lucrativos", label: t('forms.institutions.non_profit', 'Entidade sem fins lucrativos') },
        { value: "Outros", label: t('forms.institutions.others', 'Outros') }
    ];

    const ROLE_OPTIONS = [
        { value: "Executivo", label: t('forms.roles.executive', 'Executivo(a)') },
        { value: "Gerente", label: t('forms.roles.manager', 'Gerente') },
        { value: "Coordenador", label: t('forms.roles.coordinator', 'Coordenador(a)') },
        { value: "Assessor", label: t('forms.roles.advisor', 'Assessor(a)') },
        { value: "Analista/Especialista", label: t('forms.roles.analyst', 'Analista/Especialista') },
        { value: "Professor", label: t('forms.roles.teacher', 'Professor(a)') },
        { value: "Pesquisador", label: t('forms.roles.researcher', 'Pesquisador(a)') },
        { value: "Secretário(a)", label: t('forms.roles.secretary', 'Secretário(a)') }
    ];

    const [formData, setFormData] = useState({
        subject: '',
        name: '',
        email: '',
        phone: '',
        institution: '',
        role: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        if (name === 'phone') {
            const numericValue = value.replace(/\D/g, '');

            let formattedPhone = '';
            if (numericValue.length <= 2) {
                formattedPhone = `(${numericValue}`;
            } else if (numericValue.length <= 7) {
                formattedPhone = `(${numericValue.slice(0, 2)}) ${numericValue.slice(2)}`;
            } else if (numericValue.length <= 11) {
                formattedPhone = `(${numericValue.slice(0, 2)}) ${numericValue.slice(2, 7)}-${numericValue.slice(7)}`;
            } else {
                const limitedValue = numericValue.slice(0, 11);
                formattedPhone = `(${limitedValue.slice(0, 2)}) ${limitedValue.slice(2, 7)}-${limitedValue.slice(7)}`;
            }

            setFormData({
                ...formData,
                [name]: formattedPhone
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    }

    const validatePhone = (phone: string) => {
        const numericPhone = phone.replace(/\D/g, '');
        return numericPhone.length === 10 || numericPhone.length === 11;
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();

        if (!validatePhone(formData.phone)) {
            alert(t('forms.invalid_phone', 'Por favor, insira um telefone válido com 10 ou 11 dígitos.'));
            return;
        }

        setIsSubmitting(true);

        const payload = {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            company: formData.institution,
            position: formData.role,
            message: `Assunto: ${formData.subject}`
        };

        try {
            const response = await fetch('https://backend.calriz.com/api/consultor', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                alert(t('forms.success', 'Mensagem enviada com sucesso!'));
                setFormData({
                    subject: '',
                    name: '',
                    email: '',
                    phone: '',
                    institution: '',
                    role: ''
                });
            } else {
                alert(t('forms.error', 'Erro ao enviar mensagem. Tente novamente.'));
            }
        } catch (error) {
            alert(t('forms.error', 'Erro ao enviar mensagem. Tente novamente.'));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div style={{ backgroundColor: '#f2f5fe', padding: '80px 0 50px 0px', display: 'flex', width: '99%', overflow: 'hidden', paddingTop: '100px', margin: '0 0' }}>
            <div className="contact-form-container-consultor">
                <h2 className="contact-title">{t('forms.contact_us', 'Fale conosco')}</h2>
                <form className="contact-form" onSubmit={handleSubmit}>

                    <div className="contact-row">
                        <div className="contact-field-consultor">
                            <label htmlFor="subject">{t('forms.subject_label', 'Sobre qual assunto você gostaria de falar?*')}</label>
                            <select
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                            >
                                <option value="">{t('forms.select_subject', 'Selecione um assunto')}</option>
                                {SUBJECT_OPTIONS.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="contact-row">
                        <div className="contact-field-consultor">
                            <label htmlFor="name">{t('forms.name_label', 'Nome*')}</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder={t('forms.name_placeholder', 'Nome e sobrenome')}
                                required
                            />
                        </div>
                        <div className="contact-field-consultor">
                            <label htmlFor="email">{t('forms.email_label', 'E-mail corporativo*')}</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder={t('forms.email_placeholder', 'contato@suaempresa.com')}
                                required
                            />
                        </div>
                    </div>

                    <div className="contact-row">
                        <div className="contact-field-consultor">
                            <label htmlFor="phone">{t('forms.phone_label', 'Telefone*')}</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder={t('forms.phone_placeholder', '(XX) XXXXX-XXXX')}
                                required
                            />
                        </div>
                        <div className="contact-field-consultor">
                            <label htmlFor="role">{t('forms.role_label', 'Cargo*')}</label>
                            <select
                                id="role"
                                name="role"
                                value={formData.role}
                                onChange={handleChange}
                                required
                            >
                                <option value="">{t('forms.select_role', 'Selecione seu cargo')}</option>
                                {ROLE_OPTIONS.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="contact-row">
                        <div className="contact-field-consultor">
                            <label htmlFor="institution">{t('forms.institution_label', 'Instituição*')}</label>
                            <select
                                id="institution"
                                name="institution"
                                value={formData.institution}
                                onChange={handleChange}
                                required
                            >
                                <option value="">{t('forms.select_institution', 'Selecione sua instituição')}</option>
                                {INSTITUTION_OPTIONS.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <button type="submit" className="contact-btn" disabled={isSubmitting}>
                        {isSubmitting ? t('forms.sending', 'Enviando...') : t('forms.talk_to_consultant', 'Falar com um consultor')}
                    </button>
                </form>
            </div>
        </div>
    );
}